import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Eye, EyeSlash, UsersThree, EnvelopeSimple, Lock } from '@phosphor-icons/react';

const LoginPage = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const formatApiErrorDetail = (detail) => {
    if (detail == null) return 'Ha ocurrido un error. Intente nuevamente.';
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail))
      return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).filter(Boolean).join(' ');
    if (detail && typeof detail.msg === 'string') return detail.msg;
    return String(detail);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: 'var(--app-background)' }}>
      <div className="w-full max-w-sm">
        {/* Card */}
        <div className="bg-white rounded-2xl p-8" style={{ border: '1px solid var(--border-soft)', boxShadow: '0 8px 40px rgba(124, 58, 237, 0.06)' }}>
          {/* Brand */}
          <div className="flex flex-col items-center mb-8">
            {/* Icon */}
            <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5" style={{ background: 'var(--people-primary)' }}>
              <UsersThree size={28} weight="bold" className="text-white" />
            </div>
            {/* Logo */}
            <div className="text-center">
              <img src="/tupu-logo.png" alt="TUPU" className="h-8 mx-auto" />
              <span className="font-heading text-xl font-light ml-1" style={{ color: 'var(--people-primary)' }}>Personas</span>
              <p className="text-[13px] mt-1.5" style={{ color: 'var(--text-secondary)' }}>
                Asistencia &middot; Turnos &middot; Anticipos &middot; Gestion
              </p>
            </div>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
              <div className="text-sm p-3 rounded-lg flex items-start gap-2" style={{ background: 'var(--error-bg)', color: '#DC2626', border: '1px solid #FECACA' }} data-testid="login-error">
                {error}
              </div>
            )}

            <div>
              <label htmlFor="email" className="form-label text-[13px]">
                Correo electronico
              </label>
              <div className="relative">
                <EnvelopeSimple size={17} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: 'var(--text-muted)' }} />
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-input pl-10"
                  placeholder="correo@empresa.cl"
                  required
                  data-testid="login-email-input"
                />
              </div>
            </div>

            <div>
              <label htmlFor="password" className="form-label text-[13px]">
                Contrasena
              </label>
              <div className="relative">
                <Lock size={17} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: 'var(--text-muted)' }} />
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-input pl-10 pr-10"
                  placeholder="Ingresa tu contrasena"
                  required
                  data-testid="login-password-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 transition-colors"
                  style={{ color: 'var(--text-muted)' }}
                  data-testid="toggle-password-visibility"
                >
                  {showPassword ? <EyeSlash size={18} /> : <Eye size={18} />}
                </button>
              </div>
              <div className="mt-2 text-right">
                <Link
                  to="/forgot-password"
                  className="text-[12px] hover:underline transition-colors"
                  style={{ color: 'var(--people-primary)' }}
                  data-testid="forgot-password-link"
                >
                  Olvidaste tu contrasena?
                </Link>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full flex items-center justify-center gap-2 py-2.5"
              data-testid="login-submit-button"
            >
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Iniciando sesion...
                </>
              ) : (
                'Iniciar sesion'
              )}
            </button>
          </form>
        </div>

        {/* Footer */}
        <p className="text-[11px] text-center mt-5" style={{ color: 'var(--text-muted)' }}>
          TUPU &middot; Gestion integral de personas
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
